// extracted by mini-css-extract-plugin
export default {"home":"c-i_eb","home__background":"c-i_ec","home__content":"c-i_ee"};